export type ModePaiement = "especes" | "orange-money" | "moov-money" | "virement" | "cheque" | "autre";

export interface Paiement {
  id: string;
  contratId: string;
  /** Période du loyer concerné, format `YYYY-MM`. */
  periode: string;
  montant: number;
  /** Date du paiement `YYYY-MM-DD`. */
  date: string;
  mode: ModePaiement;
  reference: string;
  note: string;
  createdAt: string;
}

export type PaiementInput = Omit<Paiement, "id" | "createdAt">;

export const MODE_PAIEMENT_LABELS: Record<ModePaiement, string> = {
  especes: "Espèces",
  "orange-money": "Orange Money",
  "moov-money": "Moov Money",
  virement: "Virement bancaire",
  cheque: "Chèque",
  autre: "Autre",
};

export const MODE_PAIEMENT_ICONS: Record<ModePaiement, string> = {
  especes: "ri-money-cny-circle-line",
  "orange-money": "ri-smartphone-line",
  "moov-money": "ri-smartphone-line",
  virement: "ri-bank-line",
  cheque: "ri-file-paper-2-line",
  autre: "ri-more-line",
};

export const MODE_PAIEMENT_OPTIONS = (Object.keys(MODE_PAIEMENT_LABELS) as ModePaiement[]).map((value) => ({
  value,
  label: MODE_PAIEMENT_LABELS[value],
}));

export function paiementReference(id: string): string {
  return `PAY-${id.slice(-6).toUpperCase()}`;
}

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `paiements`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   contrat_id uuid references contrats(id) on delete cascade
 *   periode text (YYYY-MM), montant numeric, date date
 *   mode text, reference text, note text
 *   created_at timestamptz default now()
 * Chaque paiement met à jour le statut du loyer correspondant (contrat_id + periode).
 */